var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "done",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.281,
    height: 16.281,
    viewBox: "0 0 16.281 16.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27151",
    "data-name": "Path 27151",
    d: "M0,0H16.281V16.281H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27152",
    "data-name": "Path 27152",
    d: "M7.33,12.922,4.956,10.548a.672.672,0,1,0-.95.95L6.848,14.34a.676.676,0,0,0,.957,0L15,7.156a.672.672,0,0,0-.95-.95Z",
    transform: "translate(-1.225 -1.932)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cb687fb40858fa0606768a5d62d10d23.svg";
export { ForwardRef as ReactComponent };